import { Button, Stack, Typography } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { diplomaTypePageRoute } from "../DiplomaTypePage/DiplomaTypePage";
import { isAuthorized } from "services";

export const DiplomaTypeListPageHeader = (props: { rootPermission: Permission; handle: string }) => {
    const navigate = useNavigate();

    return (
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="inherit">{props.handle}</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
                {isAuthorized(props.rootPermission, PermissionAction.Create) && (
                    <Button
                        onClick={() => navigate(diplomaTypePageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }))}
                        variant="outlined"
                    >
                        + New
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};
